import React, { useEffect } from "react"
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom"

import { AuthProvider, useAuth } from "./contexts/AuthContext"
import { AxiosInterceptorSetup } from "./components/AxiosInterceptorSetup"

import IncidentsPage from "./pages/Incidents"
import IncidentPage from "./pages/Incident"
import LoginPage from "./pages/Login"
import RegisterPage from "./pages/Register"
import LogoutPage from "./pages/Logout"
import AdminPage from "./pages/Admin"
import AdminUserPage from "./pages/AdminUserPage"
import NotFound from "./pages/NotFound"
import RedirectToIncidents from "./pages/RedirectToIncidents"

import Home from "./pages/survey/Home"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function App() {
  const isProd = process.env.REACT_APP_ISPRODUCTION

  const domain = window.location.hostname
  const parts = domain.split(".")
  const subdomain = parts[0]
  
  // Consider localhost as portal in development/HML
  const isLocalhost = domain === "localhost" || domain === "127.0.0.1" || domain === "ngxnapp01"
  const isPortalSubdomain = subdomain === "portal"
  
  // Portal mode: if not production, or if subdomain is "portal", or if localhost
  const isPortal = isProd == 0 || isProd === undefined || isProd === "0" 
    ? (isLocalhost || isPortalSubdomain) 
    : isPortalSubdomain
  
  const token = (isPortalSubdomain || isLocalhost) ? localStorage.getItem("token") : null

  console.log("🔍 App Debug:", {
    isProd,
    domain,
    subdomain,
    isLocalhost,
    isPortalSubdomain,
    isPortal,
    hasToken: !!token
  })

  useEffect(() => {
    document.title = isPortal
      ? "NGXit - Portal do Cliente"
      : "NGXit - Pesquisa de Qualidade"
  }, [])

  return (
    <AuthProvider>
      <ToastContainer />
      <Router>
        <AxiosInterceptorSetup />
        <Routes>
          <Route
            path="/"
            element={!isPortal ? <NotFound /> : <RedirectToIncidents />}
          />
          <Route
            path="/login"
            element={!isPortal ? <NotFound /> : <LoginPage />}
          />
          <Route
            path="/register"
            element={!isPortal ? <NotFound /> : <RegisterPage />}
          />
          <Route
            path="/logout"
            element={!isPortal ? <NotFound /> : <LogoutPage />}
          />
          <Route
            path="/incident"
            element={!isPortal ? <NotFound /> : <IncidentsPage />}
          />
          <Route
            path="/incident/:id"
            element={!isPortal ? <NotFound /> : <IncidentPage />}
          />
          <Route
            path="/admin"
            element={!isPortal ? <NotFound /> : <AdminPage />}
          />
          <Route
            path="/admin/user/:id"
            element={!isPortal ? <NotFound /> : <AdminUserPage />}
          />

          <Route
            path="/survey/:o"
            element={isPortal ? <NotFound /> : <Home />}
          />

          {/* Rota catch-all para rotas protegidas - deve estar por último */}
          <Route
            path="*"
            element={
              token == null && isPortal ? <Navigate to="/login" /> : <NotFound />
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
